import * as i0 from "@angular/core";
export class CeoDeskService {
    setCategoryGroup(categoryGroup) {
        this.categoryGroup = categoryGroup;
    }
    getCategoryGroup() {
        return this.categoryGroup;
    }
}
CeoDeskService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CeoDeskService_Factory() { return new CeoDeskService(); }, token: CeoDeskService, providedIn: "root" });
